(function () {
    'use strict';

    /*var $ = require('jquery');

    $( '.offers-dropdown' ).on( 'mouseenter', function() {
        $('.offers-menu').toggleClass('dropdown-visible');

        if ($('html').hasClass('single-jobs') || $('html').hasClass('single-appointed_jobs')) {

            $('#header-wrap').toggleClass('no-margin--bottom');         
        }
        else {
            
            $('html').toggleClass('less-padding');
        }

    });

    $( '.offers-menu' ).on( 'mouseleave', function() {
        $('.offers-menu').removeClass('dropdown-visible');
        $('html').removeClass('less-padding');
        $('#header-wrap').removeClass('no-margin--bottom'); 
    });*/



})();